export default __webpack_public_path__ + "static/media/word_importance.2b7c3492.png";